<template>
  <div id="msgApp" class="content">
    <header class="bar bar-nav">
      <a class="button button-link button-nav pull-left" @click="toMessageManagement()">
        <span class="icon icon-left"></span>
        返回
      </a>
      <h1 class='title' style="align-content: center;font-size: smaller">{{Messages.merchantName}} </h1>
    </header>
    <div class="main" style="margin-top: 2rem">
      <dialoguecontent :messages='Messages.messages'></dialoguecontent>
      <textcontent :merchantNo='Messages.merchantNo' :messages='Messages.messages'></textcontent>
    </div>
  </div>
</template>
<script>
  import textcontent from './MessageText'
  import dialoguecontent from './MessageContent'
  import {mapMutations, mapGetters} from 'vuex'
  export default {
    components: {textcontent, dialoguecontent},
    data () {
      return {
        Messages: []
      }
    },
    methods: {
      ...mapMutations([
        'INIT_MESSAGE',
        'SEND_MESSAGE'
      ]),
//      ...mapState([
//        'leaveMessageStatus'
//        // ...
//      ]),
      readdata () {
        if (this.curMessageSession.leaveMessageStatus === 3) {
          this.gcapi('readLeaveMessageResponse', this.Messages.merchantNo)
        }
      },
      fetchData () {
        if (this.$route.query.merchandiseurl) {
          // var content = 'this.$route.query.merchandiseLabel + ' ' + this.$route.query.merchandiseurl
          var content = '<a href=' + this.$route.query.merchandiseurl + '>' + this.$route.query.merchandiseLabel + '</a>'
          let data = {}
          data.message = content
          data.merchandise = this.$route.params.merchandises
          this.SEND_MESSAGE(data, 1)
        }
      },
      create () {
//        console.log(this.Messages)
        if (this.$route.query.Messages) {
          this.Messages = this.$route.query.Messages
        }
      },
      toMessageManagement () {
        this.INIT_MESSAGE('INIT_MESSAGE')
        this.$router.push({name: 'MessageManagement'})
      }
    },
    computed: {
      // 使用对象展开运算符将 getters 混入 computed 对象中
      ...mapGetters([
        'curMessageSession'
      ])
    },
    mounted () {
      this.create()
      this.readdata()
    },
    created () {
//      this.readdata()

    }
  }
</script>

<style lang="less" scoped>
  #msgApp {
    margin: 0rem auto;

    overflow: hidden;
    border-radius: 0.1rem;
    box-sizing: border-box;

    *:before, *:after {
      box-sizing: inherit;
    }

  .sidebar, .main {
    height: 100%;
  }
  .sidebar {
    float: left;
    width: 20rem;
    color: #f4f4f4;
    background-color: #2e3238;
  }
  .main {
    position: relative;
    overflow: hidden;
    background-color: #eee;
  }
  .text {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
  }
  .message {
    height: ~'calc(100% - 10rem)';
  }
  }
</style>



// WEBPACK FOOTER //
// Message.vue?4bbe7216